import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    isModal: true,
    showModal: false,
    courses: [],
    disciplines: [],
    formData: {
      fieldOfStudy: null,
      course: null,
      residency: null,
      levelOfStudy: null,
      qualification: null,
      countryOfStudy: null,
      studyCompleted: null,
      notCompletedStudy: false,
      workExperience: 0,
      first_name: null,
      last_name: null,
      email: null,
      mobile: null,
      zip: null
    }
  },
  getters: {},
  mutations: {
    notModal (state) {
      state.isModal = false
    },
    showModal (state) {
      state.showModal = true
    },
    hideModal (state) {
      state.showModal = false
    },
    setData (state, data) {
      state.courses = data.courses
      state.disciplines = data.disciplines
    },
    setFormData (state, data) {
      state.formData[data.key] = data.value
    }
  },
  actions: {
    getData ({ commit }) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.set('action', 'eligibility_data')
        axios({
          method: 'post',
          url: window.oesEligibility?.ajaxUrl,
          data: formData,
          config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(function (response) {
          commit('setData', response.data)
          resolve(response)
        }, error => {
          alert('Fail!!')
          reject(error)
        })
      })
    },
    submitForm ({ commit, state }) {
      return new Promise((resolve, reject) => {
        window.grecaptcha.ready(function () {
          window.grecaptcha.execute(window.oesEligibility.recaptchaSiteKey, { action: 'submit' }).then(function (token) {
            const formData = new FormData()
            formData.set('action', 'eligibility_submit')
            formData.append('captchaResponse', token)
            formData.append('url', window.document.location)
            formData.append('post_id', window.oesEligibility.postID)
            formData.append('client_id', window.clientID)
            Object.keys(state.formData).forEach(key => {
              formData.set(key, state.formData[key])
            })

            // TODO Get the datalayer event attached to the state.
            // const course = $("select[name='00N90000004MYLo'] option:selected")
            // const reason = $("select[name='00N6F00000E1PuQ'] option:selected").val()
            // const title = course.text()
            // const discipline = course.data('discipline')
            // const type = course.data('application-type')
            // window.dataLayer = window.dataLayer || []
            // window.dataLayer.push({
            //   'event': 'contactUsFinish',
            //   'lead_source': 'General Enquiries',
            //   'course_name': title,
            //   'course_discipline': discipline,
            //   'course_type' : type,
            //   'reason_enquiry' : reason,
            // })

            axios({
              method: 'post',
              url: window.oesEligibility?.ajaxUrl,
              data: formData,
              config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(function (response) {
              resolve(response)
              if (state.formData.levelOfStudy === 'Work Experience' || state.formData.levelOfStudy === false) {
                if (state.formData.workExperience >= 4) {
                  window.location.href = 'https://oes-parent-theme.test/maybe-eligible-message-test'
                } else {
                  window.location.href = 'https://oes-parent-theme.test/tafe-message-test'
                }
              } else if (state.formData.levelOfStudy === 'High School') {
                if (state.formData.notCompletedStudy === true) {
                  if (state.formData.workExperience >= 4) {
                    window.location.href = 'https://oes-parent-theme.test/maybe-eligible-message-test'
                  } else {
                    window.location.href = 'https://oes-parent-theme.test/tafe-message-test'
                  }
                } else {
                  window.location.href = 'https://oes-parent-theme.test/maybe-eligible-message-test'
                }
              } else {
                if (state.formData.qualification === 'Certificate IV' || state.formData.qualification === 'Foundation Studies') {
                  if (state.formData.notCompletedStudy === false) {
                    window.location.href = 'https://oes-parent-theme.test/maybe-eligible-message-test'
                  } else {
                    if (state.formData.workExperience >= 4) {
                      window.location.href = 'https://oes-parent-theme.test/maybe-eligible-message-test'
                    } else {
                      window.location.href = 'https://oes-parent-theme.test/tafe-message-test'
                    }
                  }
                } else {
                  window.location.href = 'https://oes-parent-theme.test/maybe-eligible-message-test'
                }
              }
            }, error => {
              alert('Fail!!')
              reject(error)
            })
          })
        })
      })
    }
  },
  modules: {}
})
